function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1267 1600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "open-eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.868,322.418L385.697,530.875L870.266,563.789L903.181,320.59L383.868,322.418Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.888889,0,0,0.888889,-161.609,63.2634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 757.351,
    cy: 450.259,
    r: 33.704,
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "14.06px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.888889,0,0,0.888889,79.4688,63.2634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 757.351,
    cy: 450.259,
    r: 33.704,
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "14.06px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.871,896.905C307.871,896.905 548.631,779.573 961.58,896.905L950.913,613.479L327.68,587.574C327.68,587.574 309.395,899.953 307.871,896.905Z",
    style: {
      fill: "rgb(114,114,114)",
      stroke: "rgb(114,114,114)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.79,715.942L755.469,721.733L744.619,778.296C744.619,778.296 733.261,845.62 736.309,876.096C759.166,897.429 817.946,946.682 820.872,960.335C934.974,998.37 1090.53,1052.53 1152.56,1074.96C1221.8,1327.93 1255.8,1341.07 1218.75,1402.51C1245.08,1435.66 1264.58,1491.25 1260.68,1501.98C1160.23,1544.89 1010.88,1592.19 -0.127,1514.09C-0.127,1514.09 7.534,1440.99 39.717,1405.88C37.279,1332.01 -7.83,1445.91 111.819,1072.74C232.992,1025.66 345.347,977.083 378.87,984.702C447.441,958.797 481.668,911.309 498.133,894.615C514.847,877.668 529.135,874.806 529.135,874.806L523.123,774.479C523.123,774.479 497.273,722.381 491.79,715.942Z",
    style: {
      fill: "rgb(232,232,232)",
      stroke: "rgb(232,232,232)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.441,785.883C518.441,785.883 599.385,979.954 684.231,910.713C693.008,977.029 677.404,999.459 741.769,937.044C762.249,960.45 774.927,992.632 758.348,1069.68C731.042,1057 714.463,1052.12 693.008,1030.67C726.166,1078.45 744.695,1127.21 744.695,1145.74C801.258,1050.17 833.441,994.583 833.441,994.583L823.689,962.4L771.026,898.035C771.026,898.035 750.336,882.931 730.831,880.005C726.93,852.698 748.596,793.685 746.645,787.834C649.122,763.453 518.441,785.883 518.441,785.883Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.11,1107.71C492.11,1107.71 502.838,1187.68 541.847,1192.56C541.847,1136.97 560.376,1064.8 595.485,1067.72C597.435,1049.2 597.435,1046.27 597.435,1046.27L623.766,1022.87L595.485,1020.91C595.485,1020.91 571.104,1000.43 516.491,1143.79C507.714,1143.79 492.11,1107.71 492.11,1107.71Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.989,1035.54C653.023,1038.47 652.048,1070.65 653.023,1256.92C653.998,1443.19 656.924,1446.21 664.726,1469.52C672.528,1492.83 675.454,1501.61 687.156,1449.92C698.859,1398.23 682.28,1339.72 678.379,1296.81C674.478,1253.9 678.379,1106.64 693.983,1090.06C709.587,1073.48 720.314,1071.53 724.215,1082.26C728.116,1092.99 681.305,998.388 655.949,1018.87C630.593,1039.35 633.519,1019.84 633.519,1019.84C633.519,1019.84 576.955,1032.62 614.989,1035.54Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.489,1121.07C764.489,1121.07 738.889,1279.54 816.908,1107.66C894.926,935.775 843.727,1044.27 851.041,1021.11C858.355,997.946 807.156,1050.36 807.156,1050.36L764.489,1121.07Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.669,1011.36C865.669,1011.36 1031.46,984.536 1082.66,1118.63C1133.86,1252.73 1025.36,1407.54 1033.9,1464.84C1042.43,1522.13 1041.45,1552.85 1063.4,1558.95C1085.34,1565.04 1116.79,1311.24 1159.46,1318.55C1202.12,1325.87 1178.96,1389.26 1174.09,1420.95C1169.21,1452.65 1163.12,1477.03 1180.18,1498.97C1197.25,1520.91 1214.32,1517.26 1221.63,1535.54C1228.94,1553.83 1274.78,1537.25 1266.25,1510.43C1257.71,1483.61 1238.69,1423.39 1222.85,1408.76C1207,1394.13 1254.54,1389.26 1220.41,1295.39C1186.28,1201.53 1170.43,1099.13 1153.36,1072.31C1055.84,1033.3 922.964,990.632 897.364,983.317L871.765,976.003L865.669,1011.36Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.846,1087.39C103.846,1087.39 127.16,1046.18 190.398,1548.19C116.494,1541.63 115.427,1543.39 115.427,1543.39C115.427,1543.39 151.511,1363.95 132.981,1296.66C114.452,1229.37 130.299,1095.3 103.846,1087.39Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.668,896.139L520.304,926.761L525.999,881.51L499.668,896.139Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shirt",
    transform: "matrix(-1,0,0,1,1262.02,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.027,636.555L748.386,727.837C764.614,730.542 718.637,919.552 742.25,930.899",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.13,875.546C762.102,883.785 777.081,889.777 745.624,932.469C714.167,975.161 634.775,1004.37 631.779,1018.6C669.977,1011.11 703.681,994.523 745.624,1148.92C781.575,1091.37 821.271,1023.21 820.522,957.297C802.547,925.84 764.902,889.393 760.043,885.287",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.145,956.555C820.145,956.555 1054.46,1022.33 1153.21,1069.87C1186.12,1152.15 1198.92,1230.78 1224.52,1303.92C1244.64,1345.98 1240.98,1360.72 1224.52,1402.67C1248.29,1435.49 1251.95,1444.7 1266.58,1497.66",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.06,1086.45C1158.06,1086.45 1134.2,1101.07 1131.99,1130.43C1079.5,1381.51 1074.93,1509.51 1074.93,1534.65",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer2",
    transform: "matrix(-1,0,0,1,1262.02,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.027,636.555L748.386,727.837C764.614,730.542 718.637,919.552 742.25,930.899",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.13,875.546C762.102,883.785 777.081,889.777 745.624,932.469C714.167,975.161 634.775,1004.37 631.779,1018.6C669.977,1011.11 703.681,994.523 745.624,1148.92C781.575,1091.37 821.271,1023.21 820.522,957.297C802.547,925.84 764.902,889.393 760.043,885.287",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.145,956.555C820.145,956.555 1054.46,1022.33 1153.21,1069.87C1186.12,1152.15 1198.92,1230.78 1224.52,1303.92C1244.64,1345.98 1240.98,1360.72 1224.52,1402.67C1248.29,1435.49 1251.95,1444.7 1266.58,1497.66",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.06,1088.49C1158.06,1088.49 1134.2,1101.07 1131.99,1130.43C1079.5,1381.51 1074.93,1509.51 1074.93,1534.65",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.946,1019.3L597.369,1044.58C597.369,1044.58 614.221,1296.78 596.433,1539.85",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.176,618.777C375.992,660.982 335.258,422.17 391.431,446.512C392.367,550.433 399.857,608.479 395.176,618.777Z",
    style: {
      fill: "rgb(232,232,232)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.459,621.586C875.459,621.586 889.503,616.905 901.674,565.412C913.845,513.92 897.929,432.469 876.396,439.958C873.587,525.155 875.459,621.586 875.459,621.586Z",
    style: {
      fill: "rgb(232,232,232)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.786,188.114C645.148,231.718 757.495,354.762 830.521,416.553C840.819,477.407 832.393,500.813 832.393,639.374C741.579,814.448 704.13,821.938 632.041,844.407C522.191,828.531 459.776,687.122 438.242,630.948C429.816,620.65 430.753,542.943 438.242,412.808C485.99,398.764 635.786,188.114 635.786,188.114ZM451.306,452.176C451.306,452.176 441.007,447.495 470.967,481.199C500.926,514.903 570.206,477.454 570.206,477.454C551.109,382.229 467.986,444.763 451.306,452.176ZM697.533,475.582C735.918,515.839 791.155,479.327 791.155,479.327C791.155,479.327 827.549,460.784 811.752,450.304C721.284,390.277 691.367,455.962 697.533,475.582Z",
    style: {
      fill: "rgb(232,232,232)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.079,1041.03C481.079,1041.03 393.308,1036.64 369.902,975.197C349.422,862.557 326.016,716.272 339.182,654.832C327.479,821.597 317.239,918.145 340.645,934.237C298.222,907.905 282.131,893.277 273.354,868.408C282.131,578.764 255.799,147.154 583.478,17.029C611.272,27.338 615.661,34.652 633.215,34.652C652.232,24.412 650.769,22.949 677.101,20.023C805.832,97.554 908.231,161.92 950.654,359.405C976.985,572.981 984.299,795.334 994.539,861.163C965.282,905.048 938.951,932.842 922.86,937.231C938.951,812.889 936.025,732.432 924.322,676.843C912.62,839.22 908.231,941.62 892.14,970.877C848.254,1018.4 820.46,1034.75 797.054,1037.42C830.7,909.894 840.94,784.089 832.163,757.758C867.271,678.764 871.66,633.415 871.66,633.415L870.887,622.508L895.604,591.051L905.34,500.424L899.349,453.239L871.636,441.255L867.751,425.62C867.751,425.62 789.342,397.533 757.745,354.233C726.147,310.933 648.909,245.397 638.376,185.713C581.032,266.462 531.88,326.146 510.815,348.382C455.812,396.363 419.534,420.939 400.809,426.79C382.084,432.642 392.617,440.834 392.617,440.834L366.871,452.537L361.019,482.964L358.679,542.648L368.041,583.608L385.595,617.546L397.345,649.518L407.082,693.708L430.3,746.886L429.551,862.229L455.016,994.049L481.079,1041.03Z",
    style: {
      fill: "rgb(176,176,176)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.622,417.08L871.007,428.315C871.007,428.315 885.987,757.866 810.153,769.1C829.813,682.032 841.984,565.238 832.622,417.08Z",
    style: {
      fill: "rgb(176,176,176)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.405,429.953L437.535,411.229C437.535,411.229 419.747,616.262 445.961,705.203C472.175,794.145 464.686,772.611 464.686,772.611C464.686,772.611 401.022,752.014 397.277,620.943C393.533,489.871 395.405,429.953 395.405,429.953Z",
    style: {
      fill: "rgb(176,176,176)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M873.859,579.932C873.859,579.932 886.732,586.563 900.386,561.207C895.51,596.316 889.853,612.114 879.126,616.015C868.398,619.916 873.859,579.932 873.859,579.932Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.104,578.956C368.104,578.956 373.955,586.758 390.534,581.882C394.435,616.99 397.361,645.272 368.104,578.956Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.228,402.439C676.528,401.873 654.088,446.73 657.748,469.73L671.401,623.817C671.401,623.817 652.872,647.223 598.258,632.594C595.333,642.347 611.912,661.851 644.094,656.975C669.451,647.223 688.955,639.421 696.757,622.842C676.277,508.74 663.599,467.075 696.757,448.546C726.014,417.338 736.629,419.227 732.848,395.782C731.809,389.335 683.964,415.999 678.228,402.439Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.859,379.4C773.592,387.021 816.635,446.286 816.757,448.275C817.195,455.362 830.364,448.275 830.364,448.275L831.339,413.167L776.859,379.4Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.488,450.226C825.488,450.226 762.168,585.713 756.316,588.639C752.415,651.053 757.056,686.492 738.692,691.108C712.969,697.575 710.875,725.519 710.875,725.519L689.405,725.519C689.405,725.519 667.279,754.296 653.847,757.424C632.204,762.464 609.961,760.49 609.961,760.49C609.961,760.49 576.803,779.854 657.748,784.731C666.525,793.508 647.379,848.284 627.874,846.334C631.775,853.161 694.807,850.071 752.345,764.251C809.884,678.43 827.438,629.669 827.438,629.669C827.438,629.669 836.215,496.062 835.24,463.879C834.265,431.696 825.488,450.226 825.488,450.226Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.882,442.368C437.882,442.368 596.994,334.092 637.954,197.357L636.784,189.4C636.784,189.4 546.157,358.67 435.307,415.593C436.056,441.807 437.882,442.368 437.882,442.368Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.419,374.633C485.419,374.633 607.494,232.34 606.713,149.64C563.803,217.516 551.32,265.107 419.469,360.29C538.837,254.965 579.407,157.442 590.33,117.652L591.11,34.952L566.144,42.754L595.011,24.03L631.679,42.286L631.679,183.188C631.679,183.188 518.967,356.689 485.419,374.633Z",
    style: {
      fill: "rgb(114,114,114)",
      stroke: "rgb(114,114,114)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.89,1037.67C794.89,1037.67 870.641,1009.36 890.146,976.443C912.089,861.853 925.016,692.344 923.797,648.459C938.714,720.795 945.024,786.152 940.724,849.383C937.747,893.166 929.77,928.318 929.217,934.954C963.35,891.069 984.852,875.221 987.29,856.935C976.319,586.308 980.314,442.81 904.733,225.82C865.724,168.526 829.931,114.33 805.55,99.701C842.121,198.444 832.369,236.234 820.178,236.234C745.817,146.025 673.893,70.444 653.17,54.597C636.103,66.787 635.666,66.261 635.666,66.261L633.669,73.626C633.669,73.626 670.837,11.797 782.466,257.999C776.287,271.706 749.761,300.573 665.5,186.666C727.915,291.211 796.572,389.046 830.9,407.771C833.241,425.715 833.241,433.205 833.241,433.205L869.129,451.929L872.25,437.886C872.25,437.886 908.138,425.791 905.018,495.227C901.897,564.664 913.6,566.224 873.81,623.958C857.426,701.977 868.349,699.636 836.361,747.228L834.021,892.342L830.12,951.636L794.89,1037.67Z",
    style: {
      fill: "rgb(114,114,114)",
      stroke: "rgb(114,114,114)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.455,430.606L396.236,453.231L431.344,440.748L428.192,415.564L395.455,430.606Z",
    style: {
      fill: "rgb(114,114,114)",
      stroke: "rgb(114,114,114)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.338,650.843C397.338,650.843 405.452,1006.12 439.78,1031.2C475.356,1041.3 475.356,1046.05 475.98,1046.05C449.22,991.886 418.988,971.406 431.666,751.003C418.013,727.598 402.019,705.745 397.338,650.843Z",
    style: {
      fill: "rgb(114,114,114)",
      stroke: "rgb(114,114,114)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M676.484,401.497C670.397,410.086 661.906,410.662 650.493,401.497L669.613,426.237L676.484,401.497",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.153,400.219C591.273,412.702 602.348,409.038 614.57,403.764C610.641,402.08 606.717,422.241 586.153,418.115C558.999,412.666 571.666,400.219 571.666,400.219L586.153,400.219Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "face",
    transform: "matrix(-1,0,0,1,1263.72,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.051,645.429C641.051,645.429 644.795,632.322 660.711,637.939",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.077,442.295C873.077,442.295 901.164,432.932 903.973,489.106C906.781,545.28 900.228,608.943 873.077,619.242",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.554,853.794C742.554,853.794 795.882,856.191 831.234,867.576",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.322,890.345C913.322,890.345 918.715,892.142 928.302,894.539",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer1",
    transform: "matrix(-1,0,0,1,1263.72,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.051,645.429C641.051,645.429 644.795,632.322 660.711,637.939",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.62,413.796C425.914,632.461 431.122,674.442 464.077,778.673C379.442,729.856 388.43,568.958 394.453,428.524C527.804,388.079 630.832,183.906 630.832,183.906L632.887,183.906C632.887,183.906 735.915,388.079 869.266,428.524C875.289,568.958 884.277,729.856 799.642,778.673C832.597,674.442 837.805,632.461 831.099,413.796",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.077,442.295C873.077,442.295 901.164,432.932 903.973,489.106C906.781,545.28 900.228,608.943 873.077,619.242",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.632,745.918C835.632,745.918 842.946,1001.92 780.043,1047.27C822.466,1039.95 853.186,1020.94 894.146,975.586C917.552,852.706 924.866,810.283 923.403,649.369C943.883,798.581 935.106,886.352 923.403,940.478C958.512,914.146 967.289,906.832 990.695,867.335C964.363,409.461 1002.4,185.152 682.032,18.878C664.478,22.295 654.923,21.857 636.948,34.44C628.411,40.416 636.21,41.048 626.771,34.44C608.796,21.857 599.241,22.295 581.687,18.878C261.321,185.152 299.356,409.461 273.024,867.335C296.43,906.832 305.207,914.146 340.316,940.478C328.613,886.352 319.836,798.581 340.316,649.369C338.853,810.283 346.167,852.706 369.573,975.586C410.533,1020.94 441.253,1039.95 483.676,1047.27C420.773,1001.92 428.087,745.918 428.087,745.918",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.405,634.231C469.071,711.663 507.099,797.743 588.482,835.496C601.869,841.706 614.148,844.443 628.736,846.848L634.983,846.848C649.571,844.443 661.85,841.706 675.237,835.496C756.62,797.743 794.648,711.663 828.314,634.231",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.099,758.38L629.326,759.878L634.393,759.878L651.62,758.38",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M742.554,853.794C742.554,853.794 795.882,856.191 831.234,867.576",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.322,890.345C913.322,890.345 918.715,892.142 928.302,894.539",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.026,456.721C688.026,456.721 722.06,427.96 737.399,424.604C752.738,421.249 781.499,434.191 809.302,456.721C822.723,455.762 841.418,450.489 841.418,450.489",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.861,431.795C691.861,431.795 718.225,410.224 738.358,412.621C758.491,415.017 793.962,433.712 806.905,456.241",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.952,490.754C712.952,490.754 745.548,505.614 787.251,481.167C796.838,484.044 805.026,486.229 805.026,486.229",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.928,490.55L790.703,503.732",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.219,387.231C669.461,364.921 664.73,423.182 780.573,374.249C715.661,391.226 681.208,434.667 673.219,387.231Z",
    style: {
      fill: "rgb(77,77,77)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.398,397.263C647.398,397.263 647.694,406.05 654.761,406.533",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.5,317.974C1054.5,317.974 1092.73,307.051 1139.54,332.017C1105.99,410.816 1088.69,460.072 1083.22,469.434C1069.18,467.874 1054.5,463.869 1054.5,463.869C1054.5,463.869 1051.38,378.391 1054.5,317.974Z",
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1064.64,
    cy: 506.827,
    rx: 21.065,
    ry: 21.455,
    style: {
      fill: "rgb(176,176,176)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.418,719.997C612.729,719.016 582.207,724.786 568.999,726.488C565.137,726.985 560.466,727.806 557.062,725.021C551.115,720.156 556.521,708.432 559.59,703.737C562.472,699.327 565.547,695.016 568.999,691.036C583.412,674.416 610.506,682.757 628.418,685.543L636.973,685.543C654.885,682.757 681.979,674.416 696.392,691.036C699.844,695.016 702.919,699.327 705.801,703.737C708.87,708.432 714.276,720.156 708.329,725.021C704.924,727.806 700.253,726.985 696.392,726.488C683.184,724.786 652.662,719.016 636.973,719.997L628.418,719.997Z",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1262.39,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.026,456.721C688.026,456.721 722.06,427.96 737.399,424.604C752.738,421.249 781.499,434.191 809.302,456.721C822.723,455.762 841.418,450.489 841.418,450.489",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1262.39,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.861,431.795C691.861,431.795 718.225,410.224 738.358,412.621C758.491,415.017 793.962,433.712 806.905,456.241",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1262.39,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.952,490.754C712.952,490.754 745.548,505.614 787.251,481.167C796.838,484.044 805.026,486.229 805.026,486.229",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1262.39,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.928,490.55L790.703,503.732",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1265.39,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.219,387.231C669.461,364.921 664.73,423.182 780.573,374.249C715.661,391.226 681.208,434.667 673.219,387.231Z",
    style: {
      fill: "rgb(77,77,77)",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1265.39,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.398,397.263C647.398,397.263 647.694,406.05 654.761,406.533",
    style: {
      fill: "none",
      stroke: "rgb(77,77,77)",
      strokeWidth: "12.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M603.117,700.875C603.117,700.875 616.965,706.201 663.302,700.875",
    style: {
      fill: "none",
      stroke: "rgb(176,176,176)",
      strokeWidth: "12.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShock);
export default __webpack_public_path__ + "static/media/shock.80ce71a1979d4f95d56d7b3b28d15989.svg";
export { ForwardRef as ReactComponent };